import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'
import { updatePreferences } from 'state/actions'
import Button from 'components/button/button'
import { forIn } from 'lodash'
import copy from 'fast-copy'
import Checkbox from 'components/input/checkbox'

import SmoothCollapse from 'react-smooth-collapse'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class UserPreferences extends Component {
	constructor(props) {
        super(props)
        
        this.state = {
            showResponse: false
        }
	}

	UNSAFE_componentWillMount() {
        this.setState({
            preferences: copy(this.props.userData.email_preference)
        })
	}

	componentWillUnmount(){
        
	}

	toggleState = _ => {
        
	}

	handleChange = (event, input) => {

	}

	handleImageChange = e => {
        
	}

	handleSubmit = async _ => {
        this.setState({
	    	isLoading: true,
        });
		
	    this.props.updatePreferences(this.state.preferences, _ => {
            this.props.handleSuccess('Your preferences have been updated')
            
            this.setState({
                isLoading: false
            })
        });
    }
    
    togglePreference = key => {
        this.setState({
            preferences: {
                ...this.state.preferences,
                [key]: this.state.preferences[key] == 1 ? 0 : 1
            }
        })
    }

	render() {
        let formClass = 'auth-fields preferences'

        const {
            validateResponse,
            handleDismiss,
            closeCallback
        } = this.props

        const {
            isLoading
        } = this.state

        const emailPreferences = this.state.preferences

        let preferencesList = []

        forIn(emailPreferences, (preference, key) => {
            let preferenceObject = {
                key,
                isActive: !!preference
            }

            switch(key){
                case 'created_at':
                case 'updated_at':
                case 'id':
                case 'user_id':
                    return
                case 'ADD':
                    preferenceObject.label = "I'm added to a task"
                    break
                case 'SUBSCRIBED_PROJECT_TASK_CHANGE_ENDDATE':
                    preferenceObject.label = "Task dates are changed on a project I'm subscribed to"
                    break
                case 'SUBSCRIBED_PROJECT_TASK_CHANGE_STATUS':
                    preferenceObject.label = "A task status is changed on a project I'm subscribed to"
                    break
                case 'UPLOAD':
                    preferenceObject.label = "A file is uploaded to a task I'm involved in"
                    break
                case 'COMMENT':
                    preferenceObject.label = "A comment is posted to a task I'm involved in"
                    break
                case 'MENTION':
                    preferenceObject.label = "I'm mentioned in a comment"
                    break
                case 'POSTED_COMMENT_LIKED':
                    preferenceObject.label = "Someone likes my comment"
                    break
                case 'LIKED_COMMENT_LIKED':
                    preferenceObject.label = "Someone likes a comment I've liked"
                    break
                case 'SUBSCRIBED_PROJECT_COMMENT':
                    preferenceObject.label = "Someone comments on a project I'm subscribed to"
                    break
                case 'SUBSCRIBE':
                    preferenceObject.label = "I'm subscribed to a project"
                    break
                case 'INVITATION_ACCEPTED':
                    preferenceObject.label = "An invitation I've sent has been accepted"
                    break
                case 'WEEKLY_UPDATE':
                    preferenceObject.label = "It's time for a Monday morning update"
                    break

            }

            preferencesList.push(preferenceObject)
        })

		return (
            <div>
                <Loader visible={isLoading} />
                <form className={formClass} onSubmit={e => { e.preventDefault() }} >
                    <SmoothCollapse expanded={!!validateResponse}>
                        <ValidateResponse 
                            dismissCallback={handleDismiss} 
                            response={validateResponse} 
                            timeout={5000} 
                        />
                    </SmoothCollapse>
                    <div className="form-fields">
                        <h3>
                            Email me when...
                        </h3>
                        <ul className="preferences-list">
                            {preferencesList.map((preferenceObject, index) => {
                                return (
                                    <li key={index}>
                                        <label>
                                            <Checkbox isChecked={preferenceObject.isActive} onChange={_ => {this.togglePreference(preferenceObject.key)}} />
                                            <span>
                                                { preferenceObject.label }
                                            </span>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                        <Button 
                            size={'big'} 
                            level={'high'} 
                            callback={this.handleSubmit} 
                            label={'Save preferences'} 
                            icon={'check'} 
                        />
                        <Button 
                            size={'big'} 
                            level={'low'} 
                            callback={closeCallback} 
                            label={'Cancel'} 
                        />
                    </div>
                </form>
            </div>
		)
	}
}

const UserPreferencesWithValidation = withValidateResponse(UserPreferences)

export default connect(null, { updatePreferences })(UserPreferencesWithValidation)